import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2298b347&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=2298b347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298b347",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2298b347')) {
      api.createRecord('2298b347', component.options)
    } else {
      api.reload('2298b347', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=2298b347&scoped=true&", function () {
      api.rerender('2298b347', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/status/Detail.vue"
export default component.exports